<template>
  <div class="login" style="height: calc(100vh);width: 100%;background-color: #ffffff;">
    <div style="padding: 100px 100px;height: 300px;text-align: center">
      <div class="box">
        <el-form :model="form" status-icon ref="form" label-width="100px">
          <el-form-item label="原密码" prop="oldPassWord" :rules="[$validate.password(6,12)]">
            <el-input type="password" show-password v-model="form.oldPassWord" :maxlength="12" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPassWord" :rules="[$validate.passWord()]">
            <el-input type="password" show-password v-model="form.newPassWord" :maxlength="12" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="newPassWord2" :rules="[$validate.passWord()]">
            <el-input type="password" show-password v-model="form.newPassWord2" :maxlength="12" placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button @click="cancel">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "changeOldPass",
  components: {},
  props: [],
  data () {
    return {
      currentUserInfo: this.$store.state.currentUserInfo,
      form: {}
    }
  },
  async created () {
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async submitForm () {
      let isOK = await this.Tool.checkForm(this.$refs['form'])
      try {
        if (isOK && this.form.newPassWord == this.form.newPassWord2) {
          let param = {
            newPassWord: this.form.newPassWord,
            oldPassWord: this.form.oldPassWord,
            userId: this.currentUserInfo.userId
          }
          await this.$HTTP.ApiUser.changeOldPass(param)
          this.$message({ type: 'success', message: '操作成功' })
          this.$router.push('/index/login')
        } else {
          this.$message({ type: 'error', message: '两次密码不一致' })
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    async cancel () {
      this.$router.push('/platform/category')
    }
  }
}
</script>

<style scoped>
  .login .el-button.el-button--primary.is-disabled {
    background-color: rgba(78, 69, 238, 0.3) !important;
    border-color: rgba(78, 69, 238, 0.3) !important;
  }

  .login .el-button.el-button--primary {
    background-color: rgba(78, 69, 238, 1) !important;
    border-color: rgba(78, 69, 238, 1) !important;
  }

  .box {
    text-align: center;
    width: 600px;
    margin: 0 auto;
  }
</style>
